export default {"src":"/_next/static/media/urinary_incontinence.2306a1b7.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};